<template>
  <NuxtLayout name="base" :page="page">
    <LayoutContainer>
      <UtilityHeadline
        :text="$t('dbc-cancel-contract-headline')"
        :level="2"
        class="print:text-5xl! print:my-[2.75rem]!"
      />

      <FormsCancelContractWeAreSorry
        v-if="cancelContractState === 'infilling'"
      />

      <FormsCancelContractPrompt
        v-if="
          cancelContractState === 'infilling' ||
          cancelContractState === 'validation' ||
          cancelContractState === 'success'
        "
        :state="cancelContractState"
      />

      <FormsCancelContractInfoBox
        v-if="
          cancelContractState === 'infilling' || cancelContractState === 'error'
        "
        :state="cancelContractState"
        @onClickTryAgain="onClickTryAgain"
      />

      <FormsCancelContract
        v-if="
          cancelContractState === 'infilling' ||
          cancelContractState === 'validation'
        "
        :state="cancelContractState"
        @onClickNext="onClickNext"
        @onClickRequestCancelContract="onClickRequestCancelContract"
      />

      <FormsCancelContractPrivacyStatement
        v-if="
          cancelContractState === 'infilling' ||
          cancelContractState === 'validation'
        "
      />

      <FormsCancelContractError
        v-if="cancelContractState === 'error'"
        :formData="cancelContractFormData"
      />

      <FormsCancelContractSuccess
        v-if="cancelContractState === 'success'"
        :formData="cancelContractFormData"
      />
    </LayoutContainer>
  </NuxtLayout>
</template>

<script setup lang="ts">
const route = useRoute()

const { setLocale, locales } = useI18n()
const locale = route.params.locale as string
setLocale(locale as 'de' | 'en')

const router = useRouter()

const localizations = locales.value
  ?.filter(({ code }) => code !== locale)
  .map(({ code }) => {
    if (code !== locale) {
      return {
        id: 0,
        title: 'Kündigen',
        path: 'kuendigen',
        locale: code,
      }
    }
  }) as localization[]

const page: Page = {
  id: 0,
  title: 'Kündigen',
  path: '/kuendigen',
  description: '',
  content: [],
  localizations: localizations,
  locale: locale as string,
}

useHead({
  meta: [
    {
      name: 'robots',
      content: 'noindex',
    },
  ],
  title: locale === 'de' ? 'Kündigen' : 'Cancel Contract',
})

usePageHead(page)

const cancelContractState = ref<CancelContractStates>('infilling')

function setCancelContractState(newState: CancelContractStates) {
  cancelContractState.value = newState
  window.scrollTo(0, 0)
}

function getCancelContractState(): CancelContractStates {
  return cancelContractState.value
}

function onClickTryAgain() {
  setCancelContractState('infilling')
}

function onClickNext() {
  if (getCancelContractState() === 'infilling') {
    setCancelContractState('validation')
    router.push({ query: { state: 'validation' } })
    return
  }
  if (getCancelContractState() === 'validation') {
    setCancelContractState('infilling')
    router.push({ query: {} })
    return
  }
}

const cancelContractFormData = ref<CancelContractData | null>(null)

function onClickRequestCancelContract(
  state: CancelContractStates,
  formData: CancelContractData
) {
  cancelContractFormData.value = formData
  setCancelContractState(state)
  router.push({ query: { state } })
}

const { $aosInit } = useNuxtApp()

onMounted(() => {
  $aosInit()
  window.onpopstate = function () {
    if (getCancelContractState() !== 'infilling') {
      setCancelContractState('infilling')
      router.push({ query: {} })
    }
  }
})
</script>
